import React from 'react';
import {
	MetaSEO,
	MetaOpenGraphProduct as MetaOpenGraph,
	MetaCommon,
	MetaFavicon,
	MetaHTML,
} from './components';

export const Meta = () => (
	<>
		<MetaHTML />
		<MetaSEO />
		<MetaCommon />
		<MetaOpenGraph />
		<MetaFavicon />
	</>
);
